// Overlap-edges constraint: for each overlapping event pair (E_a, E_b)
// and each user U, enforce sum_R x_U_Ea_R + sum_R x_U_Eb_R <= 1.
// Also enforces within-event uniqueness: sum_R x_U_E_R <= 1.
// Requires model.optimizationIndexes.overlapsEdges, .users and .staffRequiredByRole
export function buildOverlapEdgesConstraints(model, _params = {}) {
  const idx = model?.optimizationIndexes || {};
  const users = Object.keys(idx.users || {});
  const edges = Array.isArray(idx.overlapsEdges) ? idx.overlapsEdges : [];
  const staffRequiredByRole = idx.staffRequiredByRole || {};
  const declared = new Set(Object.keys(idx.decisionVariables || {}));

  const constraints = [];
  // For each overlapping event pair and each user, sum over roles <= 1
  for (const edge of edges) {
    const a = edge?.a;
    const b = edge?.b;
    if (!a || !b) continue;
    const rolesA = Object.keys(staffRequiredByRole[a] || {});
    const rolesB = Object.keys(staffRequiredByRole[b] || {});
    for (const uKey of users) {
      const vars = [
        ...rolesA.map((rKey) => `x_${uKey}_${a}_${rKey}`),
        ...rolesB.map((rKey) => `x_${uKey}_${b}_${rKey}`),
      ].filter((name) => declared.has(name));
      if (!vars.length) continue;
      const coeffs = vars.map(() => 1);
      constraints.push({ linear: { vars, coeffs }, domain: [-100000, 1] });
    }
  }

  // Additionally, prevent a user from taking multiple roles within the same event
  for (const [eKey, rolesObj] of Object.entries(staffRequiredByRole)) {
    const roleKeys = Object.keys(rolesObj || {});
    if (roleKeys.length <= 1) continue;
    for (const uKey of users) {
      const vars = roleKeys.map((rKey) => `x_${uKey}_${eKey}_${rKey}`).filter((name) => declared.has(name));
      const coeffs = vars.map(() => 1);
      constraints.push({ linear: { vars, coeffs }, domain: [-100000, 1] });
    }
  }

  return constraints;
}
